import type { PermissionSelector } from "@/hooks/usePermission";

export const canListStatuses: PermissionSelector = (x) => x.isAdmin && x.repairManagement.canListStatuses;

export const canCreateTicket: PermissionSelector = (x) => x.canCreateTicket;
